<section class="relative md:py-8 py-16">
  <div class="container">
    <div class="grid grid-cols-1 pb-8 text-center">
        <h3 class="mb-4 md:text-[26px] md:leading-normal text-2xl leading-normal font-semibold">{{pagedata.titel}}</h3>

        <p class="text-slate-400 max-w-xl mx-auto">{{pagedata.welkom}}</p>
    </div>
  </div>


  <div class="container">
    <div class="grid grid-cols-1 pb-8 text-center">
        <h3 class="mb-4 md:text-[26px] md:leading-normal text-2xl leading-normal font-semibold">Onze vestigingen</h3>

        <p class="text-slate-400 max-w-xl mx-auto">{{pagedata.vestigingen_intro}}</p>
    </div>

    <div class="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 mt-4 gap-[30px]">
      <app-vestiging-card *ngFor="let vestiging of vestigingen" [vestiging]="vestiging" [details]="false"></app-vestiging-card>
    </div>
  </div>

<!-- desktop -->
<section class="relative md:py-12 py-8 overflow-hidden hidden md:block">
  <div class="container md:pb-16">
      <div class="grid md:grid-cols-12 grid-cols-1 items-top gap-[30px]">

          <div class="lg:col-span-7 md:col-span-6 md:order-2 order-1">
            <div class="shadow dark:shadow-gray-700 rounded-md bg-white dark:bg-slate-900 sticky top-20">
                <div class="flex items-center p-6">
                    <div class="w-12 h-12 flex items-center justify-center bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 rounded-md">
                      <img [src]="selectedNewsItem ? selectedNewsItem.icoon : ''" class="h-8 w-8"  alt="">
                    </div>

                    <div class="ltr:ml-3 rtl:mr-3">
                        <h5 class="text-lg font-semibold">{{ selectedNewsItem ? selectedNewsItem.titel : "" }}</h5>
                        <span class="text-earth-xdark font-medium text-sm">{{ selectedNewsItem ? selectedNewsItem.kort : "" }}</span>
                    </div>
                </div>

                <div class="p-6 border-t border-slate-100 dark:border-t-gray-700 newsitem">
                    <ul class="list-none">
                        <li class="flex items-center">
                            <i data-feather="globe" class="h-5 w-5"></i>

                            <div class="ltr:ml-4 rtl:mr-4">
                                <p class="font-normal" [innerHTML]="(selectedNewsItem ? selectedNewsItem.lang : '') | mdtohtml"></p>
                                <img class="w-11/12 mx-auto mt-8" *ngIf="selectedNewsItem?.foto" [src]="selectedNewsItem.foto" />
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

          <div class="lg:col-span-5 md:col-span-6 mt-4 md:mt-0 md:order-1 order-2">
              <div class="ltr:lg:mr-5 rtl:lg:ml-5">
                  <h3 class="mb-6 md:text-[26px] text-2xl md:leading-normal leading-normal font-semibold">Nieuws</h3>

                  <p class="text-slate-400 max-w-xl">Alle laatste nieuwtjes vanuit onze organisatie en de verschillende praktijken!</p>

                  <div *ngFor="let item of newsitems" (click)="selectedNewsItem=item" class="grid md:grid-cols-1 grid-cols-1 gap-6 mt-8 clicker">
                      <div class="p-3 rounded shadow dark:shadow-gray-700 bg-earth-dark/20 dark:bg-slate-800">
                          <div class="flex items-center">
                              <div class="w-12 h-12 flex items-center justify-center bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 rounded-md">
                                  <img [src]="item.icoon" class="h-8 w-8"  alt="">
                              </div>

                              <div class="ltr:ml-3 rtl:mr-3">
                                  <span class="block text-[16px] font-semibold hover:text-earth-xdark transition-all duration-500">{{item.titel}}</span>
                                  <span class="block text-sm text-earth-xdark">{{item.kort}}</span>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>

<!-- mobile -->
<section class="relative md:py-6 py-4 overflow-hiddenblock md:hidden">
  <div class="container md:pb-16">
    <h3 class="mb-4 md:text-[26px] text-2xl md:leading-normal leading-normal font-semibold">Nieuws</h3>
    <p class="text-slate-400 max-w-xl">Alle laatste nieuwtjes vanuit onze organisatie en de verschillende praktijken!</p>

    <div class="grid md:grid-cols-12 grid-cols-1 items-center gap-[30px] mt-4">

        <div *ngFor="let ni of newsitems" class="lg:col-span-5 md:col-span-6 md:order-2 order-1">
          <div class="shadow dark:shadow-gray-700 rounded-md bg-white dark:bg-slate-900 sticky top-20">
              <div class="flex items-center p-6 bg-earth-xdark/50">
                  <div class="w-12 h-12 flex items-center justify-center bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 rounded-md">
                    <img [src]="ni.icoon" class="h-8 w-8"  alt="">
                  </div>

                  <div class="ltr:ml-3 rtl:mr-3">
                      <h5 class="text-lg font-semibold">{{ ni.titel }}</h5>
                      <span class="text-earth-xdark font-medium text-sm">{{ ni.kort }}</span>
                  </div>
              </div>

              <div class="p-3 border-t border-slate-100 dark:border-t-gray-700 newsitem">
                  <ul class="list-none">
                      <li class="flex items-center">
                          <i data-feather="globe" class="h-5 w-5"></i>

                          <div>
                              <p class="font-normal" [innerHTML]="ni.lang | mdtohtml"></p>
                              <img class="w-5/5 mx-auto mt-8" *ngIf="ni?.foto" [src]="ni.foto" />
                          </div>
                      </li>
                  </ul>
              </div>
          </div>
      </div>
    </div>
  </div>
</section>

<a href="#" onclick="topFunction()" id="back-to-top" class="back-to-top fixed hidden text-lg rounded-full z-10 bottom-5 ltr:right-5 rtl:left-5 h-9 w-9 text-center bg-emerald-600 text-white justify-center items-center"><i class="uil uil-arrow-up"></i></a>
<script src="assets/libs/feather-icons/feather.min.js"></script>
